import classNames from 'classnames'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import { LinkDetailType } from 'service/list'
import { ReactComponent as ImageIcon } from 'svg/fi_image.svg'
import { ReactComponent as CheckIcon } from 'svg/fi_check.svg'
import { FormValues } from 'utils/type'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { CreateVideoType } from 'constant/videoTypes'
interface ProductDetailImageSelector {
  selectedLink: LinkDetailType
  index: number
  setValue: UseFormSetValue<FormValues>
  watch: UseFormWatch<FormValues>
  createVideoType: CreateVideoType
}
export const ProductDetailImageSelector = ({
  selectedLink,
  index,
  setValue,
  watch,
  createVideoType,
}: PropsWithChildren<ProductDetailImageSelector>) => {
  const MAX_CNT = 20
  const MAX_DURATION = 60
  const videoDuration = watch(`products.${index}.selectedVideoTotalDuration`)
  const [selectedImgs, setSelectedImgs] = useState<
    { order: number; imgUrl: string }[]
  >([])
  const [noDuplicateImgs, setNoDuplicateImgs] = useState<string[]>([])
  const [hoveredImage, setHoveredImage] = useState<string | null>(null)
  const [isAllImgSelect, setIsAllImgSelect] = useState<boolean>(false)
  const handleAllImgSelect = () => {
    const imgs = selectedLink?.video?.detail_images ?? []
    const bool = !isAllImgSelect
    setIsAllImgSelect(bool)

    if (bool) {
      const selected = imgs.map((imgUrl, i) => ({
        imgUrl,
        order: i + 1,
      }))
      setSelectedImgs(selected)
      setValue(`products.${index}.selectedDetails`, [...noDuplicateImgs])
    } else {
      setSelectedImgs([])
      setValue(`products.${index}.selectedDetails`, [])
    }
  }

  const updateImageArr = (imgUrl: string) => {
    const found = selectedImgs.find((img) => img.imgUrl === imgUrl)

    if (found) {
      // 선택 해제
      const filtered = selectedImgs
        .filter((img) => img.imgUrl !== imgUrl)
        .map((img, idx) => ({ ...img, order: idx + 1 }))

      setSelectedImgs(filtered)
      setValue(
        `products.${index}.selectedDetails`,
        filtered.map((i) => i.imgUrl)
      )
    } else {
      // 새로 선택

      const updated = [
        ...selectedImgs,
        { order: selectedImgs.length + 1, imgUrl },
      ]
      setSelectedImgs(updated)
      setValue(
        `products.${index}.selectedDetails`,
        updated.map((i) => i.imgUrl)
      )
    }
  }
  useEffect(() => {
    const imgs = selectedLink?.video?.detail_images

    if (imgs) {
      const uniqueImgs = Array.from(new Set(selectedLink.video.detail_images))
      setNoDuplicateImgs(uniqueImgs)

      setSelectedImgs(
        imgs.map((el, index) => {
          return { order: index + 1, imgUrl: el }
        })
      )
      setValue(`products.${index}.selectedDetails`, uniqueImgs)

      setIsAllImgSelect(true)
    }
  }, [selectedLink])

  return (
    <div className={classNames('flex flex-col w-full mt-6 relative', {})}>
      <p className="w-full font-bold flex gap-2 items-center justify-between">
        <div className="flex items-center gap-2" onClick={handleAllImgSelect}>
          {' '}
          <ImageIcon />
          상품 상세페이지 이미지 선택
        </div>

        <div
          className=" flex items-center gap-1 font-normal "
          onClick={handleAllImgSelect}
        >
          <div
            className={classNames(
              'w-[22px] h-[22px] rounded-full border-[1px] flex items-center justify-center',
              {
                'bg-href': isAllImgSelect,
                'bg-black opacity-70': !isAllImgSelect,
              }
            )}
          >
            {isAllImgSelect && <CheckIcon className="w-[12px] h-[8px]" />}
          </div>
          전체 선택
        </div>
      </p>

      <div className="bg-[#F6F8FB] w-full rounded-[10px] grid md:grid-cols-10 grid-cols-5 p-4 gap-x-[7px] gap-y-1 mt-2">
        {noDuplicateImgs.map((imgUrl, el_index) => {
          const selected = selectedImgs.find((img) => img.imgUrl === imgUrl)
          const order = selected?.order ?? 0
          return (
            <>
              <div
                className={classNames(
                  'w-[64px] relative flex items-center  bg-white rounded-[2px] overflow-hidden',
                  {
                    'h-[115px] ':
                      createVideoType === CreateVideoType.PRODUCT_SHORT,
                    'h-[64px]':
                      createVideoType === CreateVideoType.PRODUCT_LONG,
                  }
                )}
                onMouseEnter={() => setHoveredImage(imgUrl)}
                onMouseLeave={() => setHoveredImage(null)}
                onClick={() => {
                  updateImageArr(imgUrl)
                }}
              >
                {' '}
                <img src={imgUrl} referrerPolicy="no-referrer" alt="" />
                <div className="absolute flex items-center cursor-pointer right-1 bottom-1 z-50 active:scale-95">
                  <div
                    className={classNames(
                      'w-[28px] h-[28px] rounded-full border-2 flex items-center justify-center  border-href ',
                      {
                        'opacity-100 bg-white ': order > 0,
                        'bg-[rgba(0,0,0,0.5)] border-white ': order <= 0,
                      }
                    )}
                  >
                    {order > 0 && (
                      <div className="w-[22px] h-[22px] bg-href rounded-full text-white flex items-center justify-center font-bold">
                        {order}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )
        })}
      </div>
      {hoveredImage && (
        <div className="absolute bottom-0 -left-32 transform -translate-x-1/2 mt-[-200px] bg-white shadow-lg p-2 rounded-lg z-50">
          <img src={hoveredImage} alt="확대 이미지" className="w-[150px]" />
        </div>
      )}
    </div>
  )
}
